import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_USER_VEHICLE_INFO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_USER_VEHICLE_INFO`;
export const INTELLIGENT_PHOTO_CAPTURE_SET_OCR_USER_VERIFIED = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_SET_OCR_USER_VERIFIED`;
export const photoCaptureIntelligentUpdateUserVehicleInfoAction = (userVehicleInfo) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_USER_VEHICLE_INFO,
    payload: {
        userVehicleInfo
    }
});
export const photoCaptureIntelligentSetOCRUserVerifiedAction = (contentType) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_SET_OCR_USER_VERIFIED,
    payload: {
        contentType
    }
});
//# sourceMappingURL=photoCaptureIntelligentUserVehicleInfoAction.js.map